import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { XRPSCAN_API_URL } from '../../config';
import { handleResponse } from '../common/Helpers';
import { CAMPAIGN_LOCATION_KEY } from "../common/Constants";
import NexoButton from './NexoButton';
import WolfBetButton from './WolfBetButton';
import BCGameButton from './BCGameButton';
import OKXButton from './OKXButton';
// import MoonpayButton from './MoonpayButton';

const SponsorContainer = (props) => {
  // const { special } = props
  const [location, setLocation] = useState(sessionStorage.getItem(CAMPAIGN_LOCATION_KEY));

  // Return special component that is always placed at the first slot
  // const getSpecialComponent = () => {
  //   return <span className="mr-2 ml-2 mb-2"><XRPLFirewallButton /></span>
  // }

  // Fetch location
  useEffect(() => {
    if (typeof location === 'string' && location?.length === 2) {
      // Do nothing
    } else {
  		fetch(`${XRPSCAN_API_URL}/campaign/location`)
	  	.then(handleResponse)
		  .then(data => {
        if (data?.country?.length === 2) {
          setLocation(data.country);
          sessionStorage.setItem(CAMPAIGN_LOCATION_KEY, data.country);
        }
	  	})
		  .catch(error => {})
    }
  }, [location]);

  return (
    <span className="float-right d-flex flex-wrap mb-2">
        {/* {special && getSpecialComponent()} */}
        {/* <span className="ml-1 mr-1 mb-2"><FlareButton /></span> */}
        {/* <span className="ml-1 mr-1 mb-2"><UpholdButton /></span> */}
        {/* <span className="ml-1 mr-1 mb-2"><CwalletButton location={location} /></span> */}
        {/* <span className="ml-1 mr-1 mb-2"><MoonpayButton location={location} /></span> */}
        <span className="ml-1 mr-1 mb-2"><OKXButton location={location} /></span>
        <span className="ml-1 mr-1 mb-2"><WolfBetButton location={location}/></span>
        <span className="ml-1 mr-1 mb-2"><NexoButton location={location}/></span>
        <span className="ml-1 mr-1 mb-2"><BCGameButton location={location}/></span>
    </span>
  );
}

SponsorContainer.defaultProps = {
  special: false,
}

SponsorContainer.propTypes = {
	special: PropTypes.bool,
}

export default SponsorContainer;